<template>
    <div>
        <div class="">
            <div class="flex alcenter">
                <div class="ftr-1-25 ftw600">
                    {{ $t('teacherSet.teacherAccountSetting') }}({{form.is_cloaking==1?$t('teacherSet.cloaking'):$t('teacherSet.uncloaking')}})
                </div>
                <button type="button" class="btn btn-theme ms-4" @click="updateIsCloaking(1)" v-if="form.is_cloaking==2">{{ $t('teacherSet.setToCloaking') }}</button>
                <button type="button" class="btn btn-theme ms-5" @click="updateIsCloaking(2)" v-if="form.is_cloaking==1">{{ $t('teacherSet.cancelCloaking') }}</button>
            </div>
            <a-tabs v-model:activeKey="activeKey" class="ftr-1-25 mt-4 bg-w p-3">
                <a-tab-pane key="1" :tab="$t('teacherSet.teacherInfo')">
                    <div class="ftr-1 cl-black">
						<div class="ftr-1">
							{{$t('becomeTeacher.startCreateProfile')}}
						</div>
						<div class="cl-black mt-2">
							{{$t('teacherSet.realName')}} 
							<span class="cl-red">*</span>
						</div>
						<div class="flex col-sm-10 mt-2">
							<div style="width: 50%;">
								<div>{{$t('becomeTeacher.name')}}</div>
								<div>{{form.name}}</div>
								<div class="mt-2">{{$t('becomeTeacher.nameE')}}</div>
								<div>{{form.en_name}}</div>
								<!-- <div class="mt-2">{{$t('becomeTeacher.sex')}}</div>
								<div>{{}}</div> -->
								<div class="mt-2">{{$t('becomeTeacher.nationality')}}</div>
								<div>
									<a-select style="width: 220px;" size="large" v-model="form.nationality">
										<a-select-option :value="0" >
											{{$t('common.select')}}
										</a-select-option>
										<a-select-option :value="item.id" v-for="(item,index) in travelLocationL">
											{{item.name}}
										</a-select-option>
									</a-select>
								</div>
							</div>
							<div style="width: 50%;">
								<div>{{$t('becomeTeacher.surname')}}</div>
								<div>{{form.surname}}</div>
								<div class="mt-2">{{$t('becomeTeacher.surnameE')}}</div>
								<div>{{form.en_surname}}</div>
								<div class="mt-2">{{$t('teacherSet.dateBirth')}}</div>
								<!-- <div>
									<a-date-picker valueFormat="YYYY-MM-DD"
									    style="width: 100%;height: 40px;" />
								</div> -->
								<div class="mt-2">{{$t('becomeTeacher.residence')}}</div>
								<div>{{form.place_abode}}</div>
							</div>
						</div>
						<div class="mt-2">
							<div>
								{{$t('teacherSet.address')}}
							</div>
							<a-input :placeholder="$t('wallet.enter')" v-model="form.address"></a-input>
						</div>
						<div class="mt-3">
							{{$t('teacherSet.proofAddress')}}
						</div>
						<div class="flex mt-3">
							<div style="width: 150px;">
								<upload-img v-model="form.address_image"></upload-img>
							</div>
							<div>
								<div class="ftw600">{{$t('becomeTeacher.listFour2')}}:</div>
								<li>{{$t('becomeTeacher.listFour3')}}</li>
								<li>{{$t('becomeTeacher.listFour4')}}</li>
							</div>
						</div>
						
						<div class="flex col-sm-10 mt-3">
							<div style="width: 50%;">
								<div class="">{{$t('teacherSet.IDcard')}}</div>
								<div>
									<a-select style="width: 220px;" size="large" v-model="form.certificate_type">
										<a-select-option value="0" >
											{{$t('common.select')}}
										</a-select-option>
										<a-select-option value="1" >
											身份證
										</a-select-option>
										<a-select-option value="2" >
											護照
										</a-select-option>
									</a-select>
								</div>
							</div>
							<div style="width: 50%;">
								<div class="">{{$t('teacherSet.number')}}</div>
								<div>
									<a-input :placeholder="$t('wallet.enter')" v-model="form.certificate_no"></a-input>
								</div>
							</div>
						</div>
						<div class="mt-3">
							{{$t('teacherSet.copyOfidentification')}}
						</div>
						<div class="flex mt-3">
							<div style="width: 150px;">
								<upload-img v-model="form.certificate_no_image"></upload-img>
							</div>
							<div>
								<div class="ftw600">{{$t('becomeTeacher.listFour2')}}:</div>
								<li>{{$t('becomeTeacher.listFour3')}}</li>
								<li>{{$t('becomeTeacher.listFour4')}}</li>
							</div>
						</div>
						<div class="flex col-sm-10 mt-3">
							<div style="width: 50%;">
								<div class="">{{$t('becomeTeacher.phoneNumber')}}</div>
								<div>
									{{form.mobile}}
								</div>
							</div>
							<div style="width: 50%;">
								<div class="">{{$t('becomeTeacher.contactEmail')}}</div>
								<div>
									{{form.email}}
								</div>
							</div>
						</div>
						<div class="mt-3">
							{{$t('teacherSet.haveproblem')}} <span class="cl-theme">{{$t('footers.contactUs')}}</span>
						</div>
						
						<div class="mt-3 flex center">
							<div class="btn btn-theme" @click="teacherUpdate">
								{{$t('userMySetting.save')}}
							</div>
						</div>
                       <!-- <div class="cl-black">
                            {{ $t('teacherSet.avatar') }}
                        </div>
                        <div class="mt-2">
                            <upload-img v-model="form.photo_image"></upload-img>
                        </div>
                        <div class="cl-black mt-3">
                            {{ $t('teacherSet.name') }}
                        </div>
                        <a-input :placeholder="$t('teacherSet.select')" v-model="form.name" class="ftr-1 mt-2 col-sm-5" ></a-input>
                        <div class="cl-black mt-3">
                            {{ $t('teacherSet.surname') }}
                        </div>
                        <a-input :placeholder="$t('teacherSet.select')" class="ftr-1 mt-2 col-sm-5" v-model="form.surname"></a-input>
                -->
<!--                        <!-- <div class="mt-3 col-sm-6">
                            <div class="cl-black">
                                {{ $t('teacherSet.speakLanguages') }}
                            </div>
                            <div class="mt-2 flex " v-if="selectLanguageList.length>0">
                                <div v-for="(item,index) in languageL ">
                                    <div class="ml10 p-2 bg-w ft14" v-if="selectLanguageList.includes(item.id)">
                                        {{item.name}}
                                    </div>
                                </div>
                            </div>
                            <select class="form-select ft16 mt-2" v-model="form.language_id" @change="changeLanguage">
                                <option :value="0" selected>{{ $t('teacherSet.select') }}</option>
                                <option :value="item.id" v-for="(item,index) in languageL ">{{item.name}}</option>
                            </select>
                        </div> -->
						
						<!-- <div class="flex mt-3 col-sm-6">
							<div class="cl-black" style="width: 50%;padding-right: 10px;">
								{{ $t('becomeTeacher.speakLanguages') }}
							</div>
							<div class="cl-black" style="width: 50%;padding-left: 10px;">
								{{ $t('becomeTeacher.level') }}
							</div>
						</div>
						
						<div class="flex mt-2 col-sm-6">
							<div class="" style="width: 50%;padding-right: 10px;">
								<select class="form-select ft16 mt-2" v-model="language_id" @change="changeLanguage">
									<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
									<option :value="item.id" v-for="(item,index) in languageL ">{{item.name}}</option>
								</select>
							</div>
							<div class="" style="width: 50%;padding-left: 10px;">
								<select class="form-select ft16 mt-2" v-model="language_level_id"  @change="changeLevel">
									<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
									<option :value="item.id" v-for="(item,index) in languageLevelL ">{{item.name}}</option>
								</select>
							</div>
						</div>
						<div class="mt-2 flex" v-if="form.teacher_language.length>0">
							<div v-for="(item,index) in form.teacher_language" class="pos-re">
								<div class="ml10 p-2 bg-w ft14" >
									{{item.language_name}} {{item.language_level_name}}
								</div>
								<div class="pos-ab" style="top: -13px;right: -5px;" @click="form.teacher_language.splice(index,1)">
									<a-icon type="close-circle" ></a-icon>
								</div>
								
							</div>
						</div> -->
                        <!-- <div class="cl-black mt-3">
                            {{ $t('teacherSet.level') }}
                        </div>
                        <div class="col-sm-6 mt-2">
                            <select class="form-select ft16  " v-model="form.language_level_id">
                                <option :value="0" selected>{{ $t('teacherSet.select') }}</option>
                                <option :value="item.id" v-for="(item,index) in languageLevelL ">{{item.name}}</option>
                            </select>
                        </div> -->
                        
                        <!-- <div class="cl-black mt-4">
                            {{ $t('teacherSet.professorLevel') }}
                        </div>
                        <div class="mt-2 col-sm-6">
                            <select class="form-select " aria-label="Default select example" v-model="form.professor_level_id">
                                <option :value="0" selected>{{ $t('teacherSet.select') }}</option>
                                <option :value="item.id" v-for="(item,index) in professorLevelList ">{{item.name}}</option>
                            </select>
                        </div>
                        <div class="cl-black mt-3">
                            {{ $t('teacherSet.specialEducationExperience') }}
                        </div>
                        <div class="mt-2 col-sm-6">
							<a-select
							      v-model:value="form.special_educational_experience_id"
							      mode="multiple"
							      :placeholder="$t('becomeTeacher.pleaseFill')"
							      style="width: 100%"
								  showArrow
								  class="mainIndex-class-select"
								  size="large"
								  :options="specialEducationalExperienceL"
							    >
							</a-select>
                        </div> -->
                    </div>
                    <!-- <div>
                        <div class="px-3 py-3 col-sm-12 border-gray br4 bg-w mt-4">
                            <div class="ftw600 cl-black">
                                {{ $t('teacherSet.educationBackground') }}
                            </div>
                            <div class="mt-2 col-sm-6">
                                <select class="form-select " v-model="form.education_background_id">
                                    <option :value="0" selected>{{ $t('teacherSet.select') }}</option>
                                    <option :value="item.id" v-for="(item,index) in educationBackgroundL ">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="px-3 py-3 col-sm-12 border-gray br4 bg-w mt-3">
                            <div class="ftw600 cl-black">
                                {{ $t('teacherSet.certificate') }}
                            </div>
                            <div class="flex mt-2">
                                <upload-img-list v-model="form.certificate_image"></upload-img-list>
                            </div>
                        </div>
                        <div class="px-3 py-3 col-sm-12 border-gray br4 bg-w mt-3">
                            <div class="ftw600 cl-black">
                                {{ $t('teacherSet.selfIntroduction') }}
                            </div>
                            <div class="mt-3 ftr-1 cl-black">
                                {{ $t('teacherSet.synopsis') }}
                            </div>
                            <a-input :placeholder="$t('teacherSet.select')" class="ftr-1 mt-2 col-sm-6" v-model="form.synopsis" ></a-input>
                            <div class="mt-3 ftr-1 cl-black">
                                {{ $t('teacherSet.selfIntroduction') }}
                            </div>
                            <div class="">
                                <quill-editor ref="myQuillEditor" v-model="form.self_introduction_content" :options="editorOption"
                                    />
                            </div>
                            <div class="mt-3 ftr-1 cl-black">
                                {{ $t('teacherSet.imageIntroduction') }}
                            </div>
                            <div class="mt-2">
                                <upload-img-list v-model="form.introduce_images"></upload-img-list>
                            </div>
                        </div>
                        <div class="px-3 py-3 col-sm-12 border-gray br4 bg-w mt-3">
                            <div class="ftw600 cl-black">
                                {{ $t('teacherSet.video') }}
                            </div>
                            <div class="ftr-1 mt-3 cl-black">
                                {{ $t('teacherSet.uploadVideo') }}
                            </div>
                            <div class="col-sm-6 flex mt-2">
                                <a-input :placeholder="$t('teacherSet.inputYoutubeLink')" class="ftr-1" ></a-input>
                                <button type="button" class="btn btn-theme ml10" style="width: 100px;height: 40px;" @click="setVideo">{{ $t('teacherSet.confirm') }}</button>
                            </div>
                            <div class="flex mt-3">
                                <div v-for="(item, index) in form.video_files" :key="index" class="video-item pos-re">
                                    <video :src="item" class=" mr10" controls style="width: 120px;height: 120px;"></video>
                                    <a-icon type="close" size="20" class="pos-ab" style="right: 10px; top: -4px;" @click="delVideo(index)"></a-icon>
                                </div>
                            </div>
                        </div>
                    </div> -->
                   <!-- <div class="mt-5 flex" v-if="form.status!='2'">
                        <button type="button" class="btn btn-outline-gray bg-w px-4" @click="getTeacherInfo"> {{ $t('teacherSet.cancel')}}</button>
                        <button type="button" class="btn btn-theme px-4 ms-4" @click="teacherUpdate">{{ $t('teacherSet.save') }}</button>
                    </div>
                    <div class="mt-5 p-3 cl-black ftr-1" style="background-color: #FFEBE4;" v-else>
                        {{ $t('teacherSet.dataUnderReview') }}
                    </div> -->
                </a-tab-pane>
                <a-tab-pane key="2" :tab="$t('teacherSet.paymentMethod')" class="">
                    <div class="ftr-1">
						<div class="">
						    {{ $t('teacherSet.paymentMethod') }}
						</div>
						<div class="mt-3 cl-black">
							{{ $t('teacherSet.localTransfer') }}
						</div>
						<div class="mt-2">
							{{ $t('teacherSet.localTransferHint') }}
						</div>
						<div class="mt-3 cl-black">
							{{ $t('teacherSet.bankTransfer') }}
						</div>
						<div class="mt-2 flex alcenter">
							<div style="width: 160px;">{{ $t('teacherSet.nameAll') }}:</div>
							{{form.name}}{{form.surname}}
						</div>
						<div class="mt-2 flex alcenter">
							<div style="width: 160px;">{{ $t('teacherSet.bankName') }}:</div>
							<a-input :placeholder="$t('wallet.enter')" style="width: 300px;" v-model="form.withdraw_bank_name" :disabled="!isEdit"></a-input>
						</div>
						<div class="mt-2 flex alcenter">
							<div style="width: 160px;">{{ $t('teacherSet.accountNumber') }}:</div>
							<a-input :placeholder="$t('wallet.enter')" style="width: 300px;"  v-model="form.withdraw_bank_number" :disabled="!isEdit"></a-input>
						</div>
						<div class="mt-3 cl-black">
							{{ $t('teacherSet.zhuanshukuai') }}
						</div>
						<div class="mt-2 flex alcenter">
							<div style="width: 160px;">{{ $t('teacherSet.nameAll') }}:</div>
							{{form.name}}{{form.surname}}
						</div>
						<div class="mt-2 flex alcenter">
							<div style="width: 160px;">{{ $t('teacherSet.zhuanshukuai1') }}:</div>
							<a-input :placeholder="$t('wallet.enter')" style="width: 300px;"  v-model="form.withdraw_zhuanshukuai" :disabled="!isEdit"></a-input>
						</div>
						<div class="mt-3 cl-black text-underline">
							{{ $t('teacherSet.crossTransfer') }}
						</div>
						<div class="mt-3 cl-black">
							{{ $t('teacherSet.paypal') }}
						</div>
						<div class="mt-2 flex alcenter">
							<div style="width: 160px;">{{ $t('teacherSet.emailAccount') }}:</div>
							<a-input :placeholder="$t('wallet.enter')" style="width: 300px;" v-model="form.withdraw_paypal" :disabled="!isEdit"></a-input>
						</div>
						<div class="mt-4" v-if="isEdit">
							{{$t('teacherSet.fillCarefully')}}
						</div>
						<div class="mt-3" v-if="!isEdit">
							{{$t('teacherSet.haveproblem')}} <span class="cl-theme">{{$t('footers.contactUs')}}</span>
						</div>
						<div class="mt-4" v-if="isEdit">
							<a-checkbox>{{$t('teacherSet.IConfirm')}}[<span class="cl-theme" @click.stop="visible = true">{{$t('teacherSet.withdrawalArrangement')}}</span>]</a-checkbox>
						</div>
						
						<a-modal :title="$t('teacherSet.withdrawalArrangement')" :width="650" :visible="visible" @cancel="visible = false"
							:closable="false" :footer="null">
							<div class="cl-black">
								<div class="ftw600 ftr-1-25">
									{{$t('teacherSet.wArrangement1')}}
								</div>
								<div class="mt-2 ftr-1">
									1. {{$t('teacherSet.wArrangement2')}}
								</div>
								<div class="mt-2 ftr-1 flex">
									<div>
										2.
									</div>
									 {{$t('teacherSet.wArrangement3')}}
								</div>
								<div class="ftw600 ftr-1-25 mt-4">
									{{$t('teacherSet.wArrangement4')}}
								</div>
								<div class="mt-2 ftr-1">
									1. {{$t('teacherSet.wArrangement5')}}
								</div>
								<div class="mt-2 ftr-1">
									2. {{$t('teacherSet.wArrangement6')}}
								</div>
								<div class="mt-2 ftr-1">
									3. {{$t('teacherSet.wArrangement7')}}
								</div>
								<div class="mt-2 ftr-1">
									4. {{$t('teacherSet.wArrangement8')}}
								</div>
								<div class="mt-2 ftr-1">
									5. {{$t('teacherSet.wArrangement9')}}
								</div>
							</div>
							<div class="flex center mt-4">
								<div class="btn btn-theme" @click="visible = false">
									{{$t('becomeTeacher.modalSuccess4')}}
								</div>
							</div>
						</a-modal>
                    </div>
                    <div class="mt-5 flex"v-if="isEdit">
						<button type="button" class="btn btn-theme px-4 " @click="teacherUpdate">{{ $t('userMySetting.save') }}</button>
                        <button type="button" class="btn btn-outline-gray bg-w px-4 ms-4" @click="getTeacherInfo"> {{ $t('teacherSet.cancel') }}</button>
                        
                    </div>
                </a-tab-pane>
                <a-tab-pane key="3" :tab="$t('teacherSet.contactTools')">
                    <div >
                        <div class="px-3 py-3  border-gray br4 bg-w mt-3">
                            <div class=" flex alcenter">
                                <span class="ftw600 cl-black">
                                    {{ $t('teacherSet.contactTools') }}
                                </span>
                                <a-tooltip placement="rightTop">
                                    <template #title>
                                        <div class="ft14 ftw600">{{ $t('teacherSet.contactTools') }}</div>
                                    </template>
                                    <img src="../../../assets/image/staduents/1.png" width="20px" height="20px" />
                                </a-tooltip>
                            </div>
                            <div class="ftr-1 mt-3 cl-black">
                                {{ $t('teacherSet.zoom') }}
                            </div>
                            <div class="mt-3 col-sm-8 row">
                                <div class="col-sm-4">
                                    <div class="ftr-1 cl-black">
                                        {{ $t('teacherSet.meetingLink') }}
                                    </div>
                                    <a-input :placeholder="$t('teacherSet.select')" class="ftr-1  mt-2" v-model="form.contact_zoom_url"></a-input>
                                </div>
                                <div class="col-sm-4">
                                    <div class="ftr-1 cl-black">
                                        {{ $t('teacherSet.personalMeetingNumber') }}
                                    </div>
                                    <a-input :placeholder="$t('teacherSet.select')" class="ftr-1 mt-2" v-model="form.contact_zoom_pmi"></a-input>
                                </div>
                                <div class="col-sm-4">
                                    <div class="ftr-1 cl-black">
                                        {{ $t('teacherSet.meetingRoomPassword') }}
                                    </div>
                                    <a-input :placeholder="$t('teacherSet.select')" class="ftr-1 mt-2" v-model="form.contact_zoom_password"></a-input>
                                </div>
                            </div>
                            <div class="ftr-1 mt-3 cl-black">
                                {{ $t('teacherSet.voov') }}
                            </div>
                            <div class="mt-3 col-sm-8 row">
                                <div class="col-sm-4">
                                    <div class="ftr-1 cl-black">
                                        {{ $t('teacherSet.meetingLink') }}
                                    </div>
                                    <a-input :placeholder="$t('teacherSet.select')" class="ftr-1  mt-2" v-model="form.contact_voov_url"></a-input>
                                </div>
                                <div class="col-sm-4">
                                    <div class="ftr-1 cl-black">
                                        {{ $t('teacherSet.personalMeetingNumber') }}
                                    </div>
                                    <a-input :placeholder="$t('teacherSet.select')" class="ftr-1 mt-2" v-model="form.contact_voov_pmi"></a-input>
                                </div>
                                <div class="col-sm-4">
                                    <div class="ftr-1 cl-black">
                                        {{ $t('teacherSet.meetingRoomPassword') }}
                                    </div>
                                    <a-input :placeholder="$t('teacherSet.select')" class="ftr-1 mt-2" v-model="form.contact_voov_password"></a-input>
                                </div>
                            </div>
                        </div>
						<div class="ftr-1 mt-2">
							{{ $t('teacherSet.contactTools1') }}
						</div>
						<div class="ftr-1">
							<li>1 . {{ $t('teacherSet.contactTools2') }}</li>
							<li>2 . {{ $t('teacherSet.contactTools3') }}</li>
						</div>
                    </div>
                    <div class="mt-5 flex">
                        <button type="button" class="btn btn-outline-gray bg-w px-4" @click="getTeacherInfo"> {{ $t('teacherSet.cancel') }}</button>
                        <button type="button" class="btn btn-theme px-4 ms-4" @click="teacherUpdate">{{ $t('teacherSet.save') }}</button>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>

<script>
	import uploadImg from '../../../components/upload/upload.vue'
	import uploadImgList from '../../../components/upload/list.vue'
	import Quill from 'quill'
	import ImageUploader from 'quill-image-uploader';
	// 注册图片上传插件
	Quill.register('modules/imageUploader', ImageUploader);
	export default{
		components:{
			uploadImg,
			uploadImgList
		},
		data(){
			return{
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['blockquote', 'code-block'],
							[{ 'header': 1 }, { 'header': 2 }],
							[{ 'list': 'ordered'}, { 'list': 'bullet' }],
							[{ 'script': 'sub'}, { 'script': 'super' }],
							['clean'],
							['link', 'image'] // 添加图片按钮
						],
						imageUploader: {
							upload: (file) => {
								return new Promise((resolve, reject) => {
									// 替换为你的实际上传接口
									this.$http.upload(file)
										.then(response => {
											// 假设接口返回图片的 URL
											resolve(response.fullurl); 
										})
										.catch(error => {
											reject(error);
										});
								});
							}
						}
					},
					theme: 'snow'
				},
				activeKey:'1',
				form:{},
				languageL:[],
				languageLevelL:[],
				timeZoneL:[],
				travelLocationL:[],
				professorLevelList: [], //教授级别
				specialEducationalExperienceL: [], //特殊教育经历
				educationBackgroundL: [], //学历
				videoPath:[],
				selectLanguageList:[],
				language_id:0,
				language_level_id:0,
				visible:false,
				isEdit:true,//是否能够编辑支付方式
			}
		},
		async created(){
			let arr = await this.informationIntegration(['language', 'languageLevel', 'timeZone', 'travelLocation','professorLevel',
				'specialEducationalExperience', 'educationBackground'])
			this.languageL = arr.list.language.list
			this.languageLevelL = arr.list.languageLevel.list
			this.timeZoneL = arr.list.timeZone.list
			this.travelLocationL = arr.list.travelLocation.list
			this.professorLevelList = arr.list.professorLevel.list
			this.specialEducationalExperienceL = arr.list.specialEducationalExperience.list.map(item=>{
				item.value = item.id
				item.label = item.name
				return item
			})
			this.specialEducationalExperienceL.unshift({
				value:"",
				label:this.$t('common.select')
			})
			this.educationBackgroundL = arr.list.educationBackground.list
			this.getTeacherInfo()
		},
		methods:{
			updateIsCloaking(num){
				this.$http.api('teacher/teacher/updateIsCloaking',{
					is_cloaking:num
				}).then(res=>{
					this.$message.success(this.$t('common.setSuccess'),1,()=>{
						this.getTeacherInfo()
					})
				})
			},
			changeLanguage() {
			},
			changeLevel(){
				let language_name='',language_level_name = ''
				this.languageL.forEach((item,index)=>{
					if(item.id==this.language_id){
						language_name = item.name
					}
				})
				
				this.languageLevelL.forEach((item,index)=>{
					if(item.id==this.language_level_id){
						language_level_name = item.name
					}
				})
				this.form.teacher_language.push({
					language_level_name,
					language_name,
					language_id:this.language_id,
					language_level_id:this.language_level_id
				})
			},
			getTeacherInfo(){
				this.$http.api('teacher/teacher/info').then(res=>{
					res.info.nationality = Number(res.info.nationality)
					this.form = res.info
					this.updateTeacherInfo(res.info)
					this.form.teacher_language.forEach((item,index)=>{
						this.languageL.forEach((t,i)=>{
							if(item.language_id==t.id){
								item.language_name = t.name
							}
						})
						this.languageLevelL.forEach((t,i)=>{
							if(item.language_level_id==t.id){
								item.language_level_name = t.name
							}
						})
					})
					if(this.form.withdraw_bank_name&&this.form.withdraw_bank_number&&this.form.withdraw_zhuanshukuai&&this.form.withdraw_paypal){
						this.isEdit = false
					}else{
						this.isEdit = true
					}
				})
			},
			setVideo(){
				this.form.video_files.push(this.videoPath)
				this.videoPath = ''
			},
			delVideo(index){
				this.form.video_files.splice(index,1)
			},
			teacherUpdate() {
				this.$http.api('teacher/teacher/update', this.form).then(res => {
					this.$message.success(this.$t('teacherSet.submitSuccess'),2,()=>{
						this.$emit('ok')
					})
				})
			},
		}
	}
</script>

<style>
	::v-deep.ant-input{
		color: #000 !important;
	}
	.ant-input[disabled]{
		color: #000 !important;
	}
</style>